module.exports = __webpack_public_path__ + "static/media/5.482c7860.jpg";